import { render, staticRenderFns } from "./DocumentUploadSVG.vue?vue&type=template&id=cf1728c4"
import script from "./DocumentUploadSVG.vue?vue&type=script&lang=js"
export * from "./DocumentUploadSVG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports